var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13,
    r: 13,
    fill: "#BECEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 5V8C16.0003 8.55228 16.448 9 17.0003 9H20.0003M10.5003 9H12.5003M10.5003 12H16.5003M10.5003 15H16.5003M18.5003 6.5C18.0552 6.10178 17.5934 5.62948 17.3019 5.32273C17.1078 5.11861 16.8398 5 16.5582 5H9.00008C7.89551 5 7.00008 5.89542 7.00008 6.99999L7 18.9999C6.99999 20.1045 7.89542 21 8.99999 21L18 21C19.1046 21 20 20.1046 20 19L20.0003 8.39819C20.0003 8.14249 19.9028 7.8967 19.7253 7.71261C19.3971 7.37221 18.8491 6.8121 18.5003 6.5Z",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCircle);
export default __webpack_public_path__ + "static/media/fileCircle.0d4206b3c2ee3c84285913e3df11099c.svg";
export { ForwardRef as ReactComponent };